import type { FormConfig } from '@/utils/form';
import { INFO_ICON_TYPE } from '@/utils/form';
import AsyncSelect from '@/components/form-elements/AsyncSelect/AsyncSelect.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import { vorschaedenPopoverContent } from '@/features/Sparten/staticContents';
import YesNoSwitch from '@/components/form-elements/YesNoSwitch/YesNoSwitch.vue';

export const propertyBeitragsReduzierungSection: FormConfig = {
  formName: 'PropertyBeitragsreduzierung',
  fieldConfigs: [
    {
      component: AsyncSelect,
      path: 'vorversicherung',
      label: 'Vorversicherung',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.VORVERSICHERUNG,
      },
      isRequired: true,
      skipLiveValidationWhenEqual: ['unbekannt'],
    },
    {
      component: AsyncSelect,
      path: 'vorschaden',
      label: 'Vorschäden in den letzten 5 Jahren',
      infoIcon: {
        type: INFO_ICON_TYPE.POPOVER,
        content: vorschaedenPopoverContent,
      },
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.VORSCHADEN,
      },
    },
    {
      component: YesNoSwitch,
      path: 'demvRabattiert',
      label: 'Rabatte anzeigen',
    },
  ],
};
